var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "gift-chocolates.b75f45f7.png","uri@2x": __webpack_public_path__ + "gift-chocolates.5ba4d541.png","uri@3x": __webpack_public_path__ + "gift-chocolates.46038ad0.png",
    width: 88,
    height: 90
});